export const ADDNEW = 'booking/addNew';
export const REMOVE = 'booking/remove';
